module.exports = __webpack_public_path__ + "static/media/woodies.32240475.png";